import React, { useEffect, useState } from "react";
import { sendToAndroid } from "../services/androidBridge";
import { ChevronRight, Plane, PlaneTakeoff } from "lucide-react";
import {
  transferListLanguageOptions,
  utilityListLanguageOptions,
} from "./dropdown/dropdown-data";
import { BaseUrl } from "../utils/url";
const UtilityList = () => {
  const [url, setUrl] = useState("");
  const [title, setTitle] = useState();
  const [jwt, setJwt] = useState(0);
  const [data, setData] = useState([]);

  const [isFirst, setIsFirst] = useState(true);

  const handleFirstRender = (request) => {
    if (!isFirst) {
      sendDataToAndroid(request);
    }
    setIsFirst(false);
  };

  const transferClicked = (item) => {
    setUrl(item.url);
  };

  useEffect(() => {
    sendDataToAndroid("url");
  }, [url]);

  useEffect(() => {
    sendDataToAndroid("first");

    window.receiveDataFromAndroid = (data) => {
      var dataString = JSON.stringify(data);
      var obj = JSON.parse(dataString);

      if (JSON.parse(obj.request).name === "jwt") {
        const jwtValue = JSON.stringify(JSON.parse(obj.response).data);
        setJwt(jwtValue);
      }
    };
  }, []);

  useEffect(() => {
    const dataValue = [
      {
        id: 1,
        icon: Plane,
        name: utilityListLanguageOptions[jwt][0],
        fields: {
          field1: "PNR",
        },
        // url: "https://donate.hijradigital.com/airline",
        url: `${BaseUrl}/airline`,
      },
      {
        id: 2,
        icon: PlaneTakeoff,
        name: utilityListLanguageOptions[jwt][2],
        fields: {
          field1: "PNR",
        },
        url: `${BaseUrl}/flyzagol`,
      },
      // {
      //   id: 2,
      //   icon: IPS,
      //   name: utilityListLanguageOptions[jwt][1],
      //   fields: {
      //     field1: "PNR",
      //   },
      //   // url: "https://donate.hijradigital.com/airline",
      //   url: `${BaseUrl}/IPSPayment`,
      // },
    ];
    if (!isFirst) {
      setTitle(transferListLanguageOptions[jwt][1]);
    }
    setIsFirst(false);
    setData(dataValue);
  }, [jwt]);

  useEffect(() => {
    handleFirstRender("title");
  }, [title]);

  const sendDataToAndroid = (name) => {
    var transferData = {
      transferData: [],
    };
    if (name === "return") {
      transferData = {
        transferData: [
          {
            type: "return",
            request: { name: "graphData" },
            response: {},
            name: "",
          },
        ],
      };
    } else if (name === "first") {
      transferData = {
        transferData: [
          {
            type: "first",
            request: { name: "first" },
            response: {},
            name: "",
          },
        ],
      };
    } else if (name === "url") {
      transferData = {
        transferData: [
          {
            type: "url",
            request: { name: "url" },
            response: { data: url },
            name: "",
          },
        ],
      };
    } else if (name === "title") {
      transferData = {
        transferData: [
          {
            type: "title",
            request: { name: "title" },
            response: { data: title },
            name: "",
          },
        ],
      };
    } else if (name === "openLoading") {
      transferData = {
        transferData: [
          {
            type: "openLoading",
            request: { name: "openLoading" },
            response: { data: "openLoading" },
            name: "",
          },
        ],
      };
    } else if (name === "closeLoading") {
      transferData = {
        transferData: [
          {
            type: "closeLoading",
            request: { name: "closeLoading" },
            response: { data: "closeLoading" },
            name: "",
          },
        ],
      };
    } else if (name === "warning") {
      transferData = {
        transferData: [
          {
            type: "warning",
            request: { name: "warning" },
            response: { data: "warning" },
            name: "",
          },
        ],
      };
    } else if (name === "error") {
      transferData = {
        transferData: [
          {
            type: "error",
            request: { name: "error" },
            response: { data: "error" },
            name: "",
          },
        ],
      };
    } else if (name === "title") {
      transferData = {
        transferData: [
          {
            type: "title",
            request: { name: "title" },
            response: { data: title },
            name: "",
          },
        ],
      };
    }

    sendToAndroid(transferData);
    console.log(JSON.stringify(transferData));
    setUrl("");
  };

  return (
    <div className="service-screen w-full max-w-md mx-auto p-4">
      <div>
        <ul className="space-y-3">
          {data.map((item) => (
            <li
              key={item.id}
              className="flex min-h-20 cursor-pointer items-center gap-3 rounded-xl border border-slate-200 bg-white p-3.5 transition hover:border-[#7eacdf] hover:bg-[#f8fbff]"
              onClick={() => transferClicked(item)}
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-[#eef5fd] text-[#0351b3]">
                <item.icon size={24} aria-hidden="true" />
              </span>
              <span className="min-w-0 flex-1 text-sm font-semibold text-slate-800">
                {item.name}
              </span>
              <ChevronRight
                size={18}
                className="text-slate-400"
                aria-hidden="true"
              />
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default UtilityList;
